// bernie
import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

export class IndustryStore extends Store {
  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public getIndustries(): string[] {
    return [
      'airlines',
      'cashback',
      'coupons_deals',
      'content_sites',
      'closed_user_group',
      'financial_services',
      'loyalty_offers',
      'meta_sites',
      'travel_agents',
      'sub-affiliate_networks',
      'other',
    ];
  }
}
